import WaybillTemplateDTO from "@/dto/template/WaybillTemplateDTO";
import { Modal, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import MultiPlatformStorageManager from "./MultiPlatformStorageManager";
import { MultiShopSelectPlatformType } from "@/components/MultiShopSelect/types";
import { useGlobalStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import EwaybillQuantityInfo from "@/scenes/OrderManagement/components/dialogs/PrintWaybillDialog/EwaybillQuantityInfo";

interface TemplateSelectExtraProps {
    template: WaybillTemplateDTO;
    platform: MultiShopSelectPlatformType;
}

const TemplateSelectExtra: React.FC<TemplateSelectExtraProps> = function (props) {
    const { template, platform } = props;
    const [defaultTemplateId, setDefaultTemplateId] = useState<number>();

    const globalStore = useGlobalStore();

    const templates = globalStore.waybillPrintStore.waybillTemplates;

    useEffect(() => {
        const defaultTemplateId = MultiPlatformStorageManager.getPlatformDefaultWaybillTemplate(platform);

        // 快递单模板里能找到设置的默认模板才显示清除
        if (templates && templates.length && defaultTemplateId) {
            const template = templates.find((it) => it.id === defaultTemplateId);

            if (template) {
                setDefaultTemplateId(defaultTemplateId);
            }
        }
    }, []);

    if (!template) return null;

    function handleSetDefaultWaybillTemplate(e) {
        e.preventDefault();

        const { id, name } = template;

        MultiPlatformStorageManager.setPlatformDefaultWaybillTemplate(platform, id);

        Modal.success({
            title: ` 设置成功，默认快递单模板为：${name}`,
        });

        setDefaultTemplateId(id);
    }

    function handleClearDefaultWaybillTemplate(e) {
        e.preventDefault();

        MultiPlatformStorageManager.setPlatformDefaultWaybillTemplate(platform, null);

        Modal.success({
            title: "清除默认模板成功！",
        });

        setDefaultTemplateId(null);
    }

    function buildClearDefaultTemplateTypeButton() {
        if (!defaultTemplateId || !templates) return null;

        const template = templates.find((it) => it.id === defaultTemplateId);

        if (template) {
            return (
                <Tooltip title={`当前默认模板：${template.name}，点击可清除默认模板`}>
                    <a href="#" onClick={handleClearDefaultWaybillTemplate} className="mr10">
                        （清除）
                    </a>
                </Tooltip>
            );
        }

        return null;
    }

    return (
        <div>
            <a href="#" onClick={handleSetDefaultWaybillTemplate} className="mr10">
                设为默认模板
            </a>

            <EwaybillQuantityInfo template={template} />

            {buildClearDefaultTemplateTypeButton()}
        </div>
    );
};

export default observer(TemplateSelectExtra);
